<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x']"
    @close="onClose"
    custom-class="qr-fullscreen-modal"
  >
    <div class="qr-fullscreen-wrapper">
      <div class="qr-video-container">
        <QRCodeReaderVue class="qr-reader-box" @data="onQRDecode" />
      </div>

      <footer class="modal-card-foot">
        <b-button label="Close" @click="onClose" />
      </footer>
    </div>
  </b-modal>
</template>
<script>
import QRCodeReaderVue from './QRCodeReader';

export default {
  name: 'qr-code-reader-modal',
  components: {
    QRCodeReaderVue,
  },

  methods: {
    onQRDecode(data) {
      if (this.isValidUUID(data) === false) {
        this.$buefy.toast.open({
          message: 'Invalid QR Code: Not a valid Job ID',
          type: 'is-danger',
        });
        return;
      }
      this.$emit('data', data);
    },
    isValidUUID(uuidString) {
      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      return uuidRegex.test(uuidString);
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
/* Make modal full screen */
.qr-fullscreen-modal {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* Remove modal margins/padding */
.qr-fullscreen-modal .modal-background,
.qr-fullscreen-modal .modal-content,
.qr-fullscreen-modal .modal-card {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  border-radius: 0 !important;
  overflow: hidden !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Wrapper for layout */
.qr-fullscreen-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden; /* No scrollbars */
}

/* VIDEO gets all free space */
.qr-video-container {
  flex: 1; /* Take all remaining space */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

/* Video sizing */
.qr-reader-box {
  width: 100%;
  height: 100%;
}

/* Force <video> to fill container properly */
.qr-reader-box video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important; /* Video covers screen */
}

.modal-card-foot {
  background: white;
  padding: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  justify-content: end;
}
</style>
